import { LIVE_CHAT_UPDATE_STATUS } from './liveChatActionTypes';

export function updateStatus(status: string) {
  return {
    type: LIVE_CHAT_UPDATE_STATUS,
    status,
  };
}
